import React from "react"

import { Wrapper, Text } from "./notAvailableZoneStyles"

export const NotAvailableZone = () => (
  <Wrapper>
    <Text>Not available</Text>
  </Wrapper>
)
